export const USER_MONEY_TYPES = {
    INCREASE: { value: "INCREASE", text: "입금" },
    DECREASE: { value: "DECREASE", text: "출금" },
};
